import React, {Component} from 'react'
import {withRouter} from 'react-router-dom'
import {getUrlParams, pushUrlParams} from '../../services/service-url-search-params'
import styles from './ListFiltered.css'
import moment from 'moment'
import List from "../../components/List/List"
import SortList from "../SortList/SortList"
import Calendar from "../Calendar/Calendar"
import {SortBy, ComponentName, ListType, Icon} from "../../constants/consts-types"
import Modal from "../Modal/Modal"
import {TypeComponentListFiltered, TypeRoute} from "../../constants/consts-prop-types"
import TagList from "../TagList/TagList"
import PropTypes from "prop-types"
import ButtonOpenCalendar from "./ButtonOpenCalendar"
import ButtonLoadMore from "./ButtonLoadMore"
import Svg from "../Svg/Svg"

const numItemsPerPage = 18

class ListFiltered extends Component {
  static propTypes = {
    data: TypeComponentListFiltered,
    componentIndex: PropTypes.number.isRequired,
    currentRoute: TypeRoute
  }

  constructor(props, context) {
    super(props, context)

    const {
      list_type,
    } = props.data

    this.state = {
      isCalendarOpen: false,
      isLoadingMoreItems: false,
      showDatePicker: list_type === ListType.CALENDAR,
      daySize: 39,
      selectedSortingId: this.getPreSelectedSortId(),
      selectedTagId: this.getPreSelectedTagId(),
      orderBy: this.getPreSelectedOrderById(),
      startDate: moment(),
      currentPage: 0,
      searchTerm: null
    }

    this.setStateFromSearchQuery = this.setStateFromSearchQuery.bind(this)
    this.updateSearchTerm = this.updateSearchTerm.bind(this)
    this.onFilterChange = this.onFilterChange.bind(this)
    this.onStartDateChanged = this.onStartDateChanged.bind(this)
    this.onSortChange = this.onSortChange.bind(this)
    this.onTagChange = this.onTagChange.bind(this)
    this.resetStartDateCalendar = this.resetStartDateCalendar.bind(this)
    this.onOpenCalendar = this.onOpenCalendar.bind(this)
    this.onCloseCalendar = this.onCloseCalendar.bind(this)
    this.onNextPage = this.onNextPage.bind(this)
    this.autoLoadMore = this.autoLoadMore.bind(this)
  }

  componentDidMount() {
    this.updateSearchTerm()
    this.setStateFromSearchQuery(this.props.location.search)

    this.unlisten = this.props.history.listen(location => this.setStateFromSearchQuery(location.search))
  }

  componentWillUnmount() {
    this.unlisten()
  }

  componentDidUpdate(prevProps) {
    this.updateSearchTerm()

    if(this.props.currentRoute.id !== prevProps.currentRoute.id) {
      this.setState({
        isCalendarOpen: false,
        isLoadingMoreItems: false,
        showDatePicker: this.props.data.list_type === ListType.CALENDAR,
        selectedSortingId: this.getPreSelectedSortId(),
        selectedTagId: this.getPreSelectedTagId(),
        orderBy: this.getPreSelectedOrderById(),
        startDate: moment(),
        currentPage: 0,
      })
    }

    if(this.props.data.items.length !== prevProps.data.items.length) {
      this.setState({
        isLoadingMoreItems: false,
      })
    }
  }

  getPreSelectedSortId() {
    const {
      pre_selected_sort,
    } = this.props.data

    return pre_selected_sort ? pre_selected_sort : ''
  }

  getPreSelectedTagId() {
    const {
      pre_selected_tag,
    } = this.props.data

    return pre_selected_tag && pre_selected_tag.slug ? pre_selected_tag.slug : ''
  }

  getPreSelectedOrderById() {
    const {
      pre_selected_order,
    } = this.props.data

    return pre_selected_order ? pre_selected_order : SortBy.ASC
  }

  setStateFromSearchQuery(search) {
    const urlParams = getUrlParams(search)

    const {
      order,
      size,
      sort_by,
      start_date,
      tag
    } = urlParams

    const newState = Object.assign(
      {
        selectedSortingId: this.getPreSelectedSortId(),
        selectedTagId: this.getPreSelectedTagId(),
        orderBy: this.getPreSelectedOrderById(),
        startDate: moment(),
        currentPage: 0
      },
      order ? {orderBy: order} : {},
      size ? {currentPage: (Math.floor((size || 0) / numItemsPerPage) - 1)} : {},
      sort_by ? {selectedSortingId: sort_by} : {},
      start_date ? {startDate: moment(start_date)} : {},
      tag ? {selectedTagId: tag} : {}
    )

    this.setState(newState)
  }

  updateSearchTerm() {
    const {
      data,
      location,
    } = this.props

    if(Boolean(data.component_id === ComponentName.search_items) && location.search) {
      const searchTermDecoded = location.search.split('?q=')[1] ? decodeURIComponent(location.search.split('?q=')[1].split('&')[0]) : ''
      if(this.state.searchTerm === searchTermDecoded) return

      this.setState({
        searchTerm: searchTermDecoded
      })
    }
  }

  onFilterChange() {
    const {
      showDatePicker,
      startDate,
      currentPage,
      selectedTagId,
      selectedSortingId
    } = this.state

    const newQueryParams = Object.assign({},
      selectedTagId && {tag: selectedTagId},
      this.state.searchTerm && {q: this.state.searchTerm},
      showDatePicker && startDate && {start_date: this.state.startDate.format('YYYYMMDD')},
      {
        sort_by: selectedSortingId,
        order: this.state.orderBy,
        offset: 0,
        size: ((currentPage + 1) * numItemsPerPage),
      },
    )

    pushUrlParams(this.props.history, newQueryParams)
  }

  onStartDateChanged(startDate) {
    this.setState({
      isCalendarOpen: false,
      startDate: startDate,
      currentPage: 0
    }, () => this.onFilterChange());
  }

  onSortChange(sortId) {
    if(sortId === this.state.selectedSortingId) {
      this.setState(prevState => ({
        orderBy: prevState.orderBy === SortBy.ASC ? SortBy.DESC : SortBy.ASC
      }), () => this.onFilterChange())
      return
    }

    this.setState({
      selectedSortingId: sortId
    }, () => this.onFilterChange())
  }

  onTagChange(tagId) {
    if(tagId === this.state.selectedTagId) return

    this.setState({
      selectedTagId: tagId,
      currentPage: 0
    }, () => this.onFilterChange())
  }

  resetStartDateCalendar() {
    if(this.state.startDate.format('l') === moment().format('l')) return
    this.setState({
      startDate: moment(),
      currentPage: 0
    }, () => this.onFilterChange());
  }

  onOpenCalendar() {
    this.setState({
      isCalendarOpen: true
    });
  }

  onCloseCalendar() {
    this.setState({
      isCalendarOpen: false
    });
  }

  onNextPage(event) {
    if(event) event.preventDefault()

    this.setState(prevState => ({
      isLoadingMoreItems: true,
      currentPage: prevState.currentPage + 1
    }), () => {
      this.onFilterChange()
    })
  }

  autoLoadMore(inview) {
    if(inview && !this.state.isLoadingMoreItems) {
      this.onNextPage()
    }
  }

  render() {
    const {
      currentRoute,
      componentIndex,
      data
    } = this.props

    const {
      items,
      total,
      title,
      tags,
      sortings,
      list_type,
      navigation_link,
    } = data

    const {
      isLoadingMoreItems,
      showDatePicker,
      selectedTagId,
      selectedSortingId,
      isCalendarOpen,
      startDate,
      searchTerm
    } = this.state

    const pageTitle = currentRoute.title
    const headerLight = currentRoute.header_light
    const showButtonLoadMore = Boolean(items && items.length < total) || isLoadingMoreItems
    const showSortList = Boolean(sortings && sortings.length > 0)

    return (
      <section className={styles.ListFiltered}>
        {isCalendarOpen && (
          <Modal>
            <Calendar
              language={currentRoute.language}
              date={startDate}
              onDateChanged={this.onStartDateChanged}
              onCloseCalendar={this.onCloseCalendar}
            />
          </Modal>
        )}

        <div className={`container-fluid ${styles.sectionHeaders}`}>
          <div className="row bottom-xs">
            <div className="col-xs-12 col-sm-5">
              {title && list_type !== ListType.CALENDAR && (
                <h1
                  className={
                    componentIndex > 0 ? styles.headerNoMargin : styles.header
                  }
                  dangerouslySetInnerHTML={{ __html: title }}
                />
              )}
              {headerLight && list_type === ListType.CALENDAR && (
                <h1
                  className={
                    componentIndex > 0
                      ? styles.headerLightNoMargin
                      : styles.headerLight
                  }
                  dangerouslySetInnerHTML={{ __html: headerLight }}
                />
              )}
              {this.props.data.component_id === ComponentName.search_items &&
                searchTerm && (
                  <h2
                    className={
                      componentIndex > 0 ? styles.headerNoMargin : styles.header
                    }
                  >
                    {pageTitle}: '{searchTerm}'
                  </h2>
                )}
              {currentRoute.excerpt && (
                <div
                  className={styles.listDescription}
                  dangerouslySetInnerHTML={{ __html: currentRoute.excerpt }}
                />
              )}
            </div>

            <div className="col-xs-12 col-sm-offset-1 col-sm-6 col-md-offset-1 col-md-6">
              <div className={styles.sortWrapper}>
                {navigation_link && (
                  <a
                    href={navigation_link.url}
                    className={styles.navigationLink}
                  >
                    <span>{navigation_link.label}</span>
                    <Svg
                      className={styles.navigationLinkIcon}
                      id={Icon.ARROW_LONG_RIGHT}
                    />
                  </a>
                )}
                {showSortList && (
                  <SortList
                    data={sortings}
                    selectedSortingId={selectedSortingId}
                    orderBy={this.state.orderBy}
                    onSortChange={this.onSortChange}
                  />
                )}
              </div>
            </div>
          </div>
        </div>

        {Boolean(showDatePicker || Boolean(tags && tags.length > 0)) && (
          <div className={`container-fluid ${styles.sectionFilters}`}>
            <div className="row">
              <div className="col-xs-12 col-sm-5 col-md-5">
                {showDatePicker && (
                  <ButtonOpenCalendar
                    language={currentRoute.language}
                    startDate={startDate}
                    resetStartDateCalendar={this.resetStartDateCalendar}
                    onOpenCalendar={this.onOpenCalendar}
                  />
                )}
              </div>

              <div className="col-xs-12 col-md-offset-1 col-md-6">
                {tags && tags.length > 0 && (
                  <TagList
                    data={tags}
                    selectedTagId={selectedTagId}
                    onTagChange={this.onTagChange}
                  />
                )}
              </div>
            </div>
          </div>
        )}

        <List listItems={items} />

        <ButtonLoadMore
          items={items}
          showButtonLoadMore={showButtonLoadMore}
          isLoadingMoreItems={isLoadingMoreItems}
          autoLoadMore={this.autoLoadMore}
          onNextPage={this.onNextPage}
        />
      </section>
    );
  }
}

export default withRouter(ListFiltered)



// WEBPACK FOOTER //
// ./src/components/ListFiltered/ListFiltered.js